import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home/home';
import Product from './components/pages/Product/Product';
import Contact from './components/pages/contact/Contact';
import About from './components/pages/about/About';
import Mechatronics from './components/pages/mechatronics/Mechatronics';
import ChannelPartner from './components/pages/channel-partner/ChannelPartner';
import AuthorisedServiceCentre from './components/pages/authorised-service-centre/AuthorisedServiceCentre';
import IndustrialSolutions from './components/pages/industrial-solutions/IndustrialSolutions';
import PlasticMoulding from './components/pages/plastic-moulding/PlasticMoulding';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/mechatronics" element={<Mechatronics />} />
        <Route path="/channel-partner" element={<ChannelPartner />} />
        <Route path="/authorised-service-centre" element={<AuthorisedServiceCentre />} />
        <Route path="/industrial-solutions" element={<IndustrialSolutions />} />
        <Route path="/plastic-moulding" element={<PlasticMoulding />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
